export const YODLEE_ONCLOSE_STATUSES = {
  ACTION_ABANDONED: 'ACTION_ABANDONED',
  FAILED: 'FAILED',
  MIGRATION_IN_PROGRESS: 'MIGRATION_IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  USER_CLOSE_ACTION: 'USER_CLOSE_ACTION',
}
